import React from 'react'
import { cx } from '@emotion/css'
import styles from './styles'

/**
 * DropdownLink component
 *
 * @param {Object} props
 * @param {boolean} [props.active]
 * @param {string} [props.href]
 * @param {string} [props.target]
 * @param {() => void} [props.onClick]
 * @param {string} props.label
 * @param {string} [props.rel]
 *
 * @returns {JSX.Element}
 */
const DropdownLink = ({ active, href, target, onClick, label, rel }) => (
  <li>
    <a
      href={href}
      target={href ? target : undefined}
      onClick={onClick}
      rel={rel}
      role="presentation"
      tabIndex={0}
      className={cx(styles.link, active && styles.linkActive)}>
      {label}
    </a>
  </li>
)

export default DropdownLink
